import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "map" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "map",
  class: "map"
}, null, -1)
const _hoisted_3 = {
  key: 0,
  id: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.status_text != '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.status_text), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}